import { Typography } from '@components';
import React from 'react';

interface ticketDetailHeader {
  company: string;
  ticket_id: number;
  created_at: Date;
  issuer?: string;
}

export const TicketDetailHeader = ({
  company,
  ticket_id,
  created_at,
  issuer,
}: ticketDetailHeader) => {
  return (
    <div className="grid grid-cols-4 border border-gray-200 rounded-lg mb-4">
      <div className="border-r border-gray-200 p-2">
        <Typography tag="p" type="labelSemiBold">
          Klant
        </Typography>
        <Typography tag="label" type="label">
          {company}
        </Typography>
      </div>
      <div className="border-r border-gray-200 p-2">
        <Typography tag="p" type="labelSemiBold">
          Ticket
        </Typography>
        <Typography tag="label" type="label">
          #{ticket_id}
        </Typography>
      </div>
      <div className="border-r border-gray-200 p-2">
        <Typography tag="p" type="labelSemiBold">
          Issuer
        </Typography>
        <Typography tag="label" type="label">
          {issuer ? issuer : 'NA'}
        </Typography>
      </div>
      <div className="border-r border-gray-200 p-2">
        <Typography tag="p" type="labelSemiBold">
          Aangemaakt
        </Typography>
        <Typography tag="label" type="label">
          {created_at}
        </Typography>
      </div>
    </div>
  );
};

export default TicketDetailHeader;
